export default __webpack_public_path__ + "static/media/elevate-swarovski-poster-2.72151c36.jpg";